import constants from '../../../../../libs/constant/constants'

export default{
    name: 'AuthorConfirmation',
    props:{
        claimTo: {
            type: Object,
            default: () => {}
        },
        module: {
            type: String,
            default: () => constants.AUTHOR.key
        },
        isAdmin: {
            type: Boolean,
            default: false
        },
        organisationDetails: {
            type: Object,
            default: () => {}
        }
    },
    methods: {
        routeTo(){
            if (this.isAdmin) {
                this.$store.dispatch('setAddPublisher', false)
                this.$router.push({name: 'info-publishers'})
            } else if (this.organisationDetails._id) {
                this.$router.push({name: 'org-publications'})
            } else {
                this.$router.push('/ip/card')
            }
            
        }
    }
}